/**
 * @generated SignedSource<<35b0af6e6010b28b75c7cf9c34075839>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type MyBuilds_viewer$fragmentType = any;
export type MyBuildsQuery$variables = {||};
export type MyBuildsQuery$data = {|
  +viewer: ?{|
    +$fragmentSpreads: MyBuilds_viewer$fragmentType,
  |},
|};
export type MyBuildsQuery = {|
  response: MyBuildsQuery$data,
  variables: MyBuildsQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MyBuilds_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MyBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdc1d2692ca7025c81c61de2713c3de4",
    "id": null,
    "metadata": {},
    "name": "MyBuildsQuery",
    "operationKind": "query",
    "text": "query MyBuildsQuery {\n  viewer {\n    ...MyBuilds_viewer\n    id\n  }\n}\n\nfragment MyBuilds_viewer on Viewer {\n  user {\n    id\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "c6927dfa89450d046e262aa4b0b45ef7";

module.exports = ((node/*: any*/)/*: Query<
  MyBuildsQuery$variables,
  MyBuildsQuery$data,
>*/);
